import { render, staticRenderFns } from "./WaitingRoomCandidateAvatar.vue?vue&type=template&id=e3db8092&scoped=true"
import script from "./WaitingRoomCandidateAvatar.vue?vue&type=script&lang=js"
export * from "./WaitingRoomCandidateAvatar.vue?vue&type=script&lang=js"
import style0 from "./WaitingRoomCandidateAvatar.vue?vue&type=style&index=0&id=e3db8092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3db8092",
  null
  
)

export default component.exports